import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

import FloatNumberFormatText from '../../components/float_number_text_formatter';

//const drawerWidth = 240;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    observTextField: {
        display: 'flex',
        height: '100%',
        margin: theme.spacing(1),
    },
    inputObserv: {
        display: 'flex',
        alignItems: 'start',
        margin: '15px 0',
        padding: '5px 8px',

    },
    button: {
        margin: '15px 15px 15px 0',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    title: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(3),
    }
});

class CierreDiarioObservaciones extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            obsBolera: '',
            obsBar: '',
            obsArcade: '',
            error: '',
            obs: undefined
        };
    };

    componentDidMount = () => {

        let obsBolera = '';
        let obsBar = '';
        let obsArcade = '';
        let obs = [...this.props.obs];

        if (obs === undefined) obs = [];

        if (Math.abs(this.props.descuadreBolera) > 5) {
            let bolera = obs.find(o => o.iTipoZona === 0);
            if (bolera === undefined) {
                obs.push({ iTipoZona: 0, cajaId: this.props.cajaBolera, observaciones: '' });
            }
            else {
                obsBolera = bolera.observaciones
            }
        }

        if (Math.abs(this.props.descuadreBar) > 5) {
            let bar = obs.find(o => o.iTipoZona === 1);
            if (bar === undefined) {
                obs.push({ iTipoZona: 1, cajaId: this.props.cajaBar, observaciones: '' });
            }
            else {
                obsBar = bar.observaciones;
            }
        }

        if (Math.abs(this.props.descuadreArcade) > 5) {
            let arcade = obs.find(o => o.iTipoZona === 5);
            if (arcade === undefined) {
                obs.push({ iTipoZona: 5, cajaId: this.props.cajaArcade, observaciones: '' });
            }
            else {
                obsArcade = arcade.observaciones
            }
        }

        this.setState({ obsBolera: obsBolera, obsBar: obsBar, obsArcade: obsArcade, obs: obs });

    }


    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };


    render() {
        const { classes } = this.props;

        return (

            <form className={classes.root} autoComplete="off">

                <div>

                    {Math.abs(this.props.descuadreBolera) >= 5 ?
                        <div>
                            <Typography variant="subtitle1" color='secondary'>{"Observaciones de descuadre de Bolera"}</Typography>
                            <Typography variant="subtitle2">{"Descuadre: "}<FloatNumberFormatText value={this.props.descuadreBolera}></FloatNumberFormatText></Typography>
                            <TextField
                                className={classes.observTextField}
                                placeholder={this.props.label}
                                InputProps={{
                                    className: classes.inputObserv,
                                }}
                                id={'observDescuadreBolera'}
                                value={this.state.obsBolera}
                                variant='outlined'
                                multiline
                                rowsMax='5'
                                rows='5'
                                onChange={(event) => this.handleValueChange(event, 'obsBolera')}
                            />
                        </div>
                        : ''}

                    {Math.abs(this.props.descuadreBar) >= 5 ?
                        <div>
                            <Typography variant="subtitle1" color='secondary'>{"Observaciones de descuadre de Bar"}</Typography>
                            <Typography variant="subtitle2">{"Descuadre: "}<FloatNumberFormatText value={this.props.descuadreBar}></FloatNumberFormatText></Typography>
                            <TextField
                                className={classes.observTextField}
                                placeholder={this.props.label}
                                InputProps={{
                                    className: classes.inputObserv,
                                }}
                                id={'observDescuadreBar'}
                                value={this.state.obsBar}
                                variant='outlined'
                                multiline
                                rowsMax='5'
                                rows='5'
                                onChange={(event) => this.handleValueChange(event, 'obsBar')}
                            />
                        </div>
                        : ''}


                    {Math.abs(this.props.descuadreArcade) >= 5 ?
                        <div>
                            <Typography variant="subtitle1" color='secondary'>{"Observaciones de descuadre de Arcade"}</Typography>
                            <Typography variant="subtitle2">{"Descuadre: "}<FloatNumberFormatText value={this.props.descuadreArcade}></FloatNumberFormatText></Typography>
                            <TextField
                                className={classes.observTextField}
                                placeholder={this.props.label}
                                InputProps={{
                                    className: classes.inputObserv,
                                }}
                                id={'observDescuadreArcade'}
                                value={this.state.obsArcade}
                                variant='outlined'
                                multiline
                                rowsMax='5'
                                rows='5'
                                onChange={(event) => this.handleValueChange(event, 'obsArcade')}
                            />
                        </div>
                        : ''}

                    <Typography variant="subtitle1" color='error'>{this.state.error}</Typography>

                    <div className={classes.bottomBtn}>
                        <Button variant="contained" color="primary" className={classes.button} disabled={this.state.value === ''} onClick={() => {
                            
                            const newObs = [...this.state.obs];

                            newObs.forEach(o => {
                                if (o.iTipoZona === 0) o.observaciones = this.state.obsBolera;
                                if (o.iTipoZona === 1) o.observaciones = this.state.obsBar;
                                if (o.iTipoZona === 5) o.observaciones = this.state.obsArcade;
                            });

                            if ((Math.abs(this.props.descuadreBolera) > 5 && this.state.obsBolera.trim() === '') ||
                                (Math.abs(this.props.descuadreBar) > 5 && this.state.obsBar.trim() === '') ||
                                (Math.abs(this.props.descuadreArcade) > 5 && this.state.obsArcade.trim() === '')) {
                                this.setState({ ...this.state, error: 'ERROR: No se puede dejar un texto de observaciones vacío' });
                            } else {
                                this.props.hideDialog();
                                this.props.okHandler({ arqueos: newObs });
                            }
                        }}>Guardar</Button>
                    </div>

                </div>

            </form>
        );

    };

};

CierreDiarioObservaciones.propTypes = {
    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    okHandler: PropTypes.func.isRequired,
    obs: PropTypes.string.isRequired,
    descuadreBar: PropTypes.number.isRequired,
    descuadreBolera: PropTypes.number.isRequired,
    descuadreArcade: PropTypes.number.isRequired

};


export default withStyles(styles, { withTheme: true })(CierreDiarioObservaciones);